import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom";
import firebase from 'firebase/app';
import "firebase/auth";
import { hasSubscriptions } from "firebase/checkout";
import db from 'firebase/dbConfig'

const UserContext = React.createContext()

function UserContextProvider(props){
  const [isSignedIn, setIsSignedIn] = useState(true)
  const [currentUser, setCurrentUser] = useState("")
  const [pendingAuth, setPendingAuth] = useState(true)
  const [loginCompleted, setLoginCompleted] = useState(false)
  const [userProfile, setUserProfile] = useState({})
  const [userOptions, setUserOptions] = useState({})
  const [groups, setGroups] = useState([])
  const [groupName, setGroupName] = useState("")
  //const [creationTime, setCreationTime] = useState("")
  const [recordsCount, setRecordsCount] = useState("")
  const [isPro, setIsPro] = useState(false)
  const history = useHistory();

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      setIsSignedIn(!!user)
      setCurrentUser(user)
      setPendingAuth(false)
      }
    )
  }, [])

  useEffect(() => {
    if (currentUser){
      db.collection('users').doc(currentUser.uid).onSnapshot(function(doc) {
        setUserProfile(doc.data().profile)
        setUserOptions(doc.data().options)
        setGroupName(doc.data().groupName)
        setRecordsCount(doc.data().recordsCount)
      });
      async function haveSubs () {
        const subscribed = await hasSubscriptions(currentUser.uid)
        setIsPro(subscribed)
      }
      haveSubs()
      //setCreationTime(currentUser.metadata.creationTime)
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentUser){
      db.collection('groups').onSnapshot(snapshot => {
        const allRecords = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setGroups(allRecords)
      });
    }
  }, [currentUser]);

  function signOut() {
    firebase.auth().signOut().then(function() {
      sessionStorage.removeItem('tokenK');
      sessionStorage.removeItem('displayName');
      sessionStorage.removeItem('userName');
      window.location.href = 'https://avaliacaopreanestesica.com'
      }).catch(function(error) {
        console.log("Erro ao fazer logout")
    })
  }

  if (pendingAuth) {
    return <> Carregando... </>
  }

  return <UserContext.Provider value={{isSignedIn, pendingAuth, signOut,
                                      loginCompleted, setLoginCompleted,
                                      currentUser, isPro, userProfile,
                                      userOptions, groupName, groups, recordsCount}}>
            {props.children}
         </UserContext.Provider>
}

export  {UserContextProvider, UserContext}
